import actions from './actionTypes';
import * as api from '../services/api';
import { getOneLevelPatterns, createResponseObject } from './modalActions';
import { string } from '../localization';
import * as Constants from '../utilities/constants/Constants';
import { setMessageDialogParams, setLoadingState } from './fabricCanvasActions';
import {
  setShowLoading,
  setShouldLoadMoreContents,
  setIsMaximumLimit
} from './sideBarActions';

export const fetchPremiumContents = (theme, dispatch) => {
  dispatch(setLoadingState(string.LOADING_KEY));
  dispatch(setSearchContents(false, null));
  if (
    theme.name.search('Pattern Design') !== -1 ||
    Object.prototype.hasOwnProperty.call(theme, 'isPremium')
  ) {
    dispatch(fetchPatternContents(theme));
  } else if (theme.name.search('Unsplash') !== -1) {
    dispatch(fetchUnsplashContents(theme));
  } else if (theme.name.search('Dreamstime') !== -1) {
    dispatch(fetchDreamstimeContents(theme));
  } else if (theme.name.search('Getty Images') !== -1) {
    dispatch(fetchGettyImageContents(theme));
  } else if (theme.name.search('iStock') !== -1) {
    dispatch(fetchIStockContents(theme));
  } else if (theme.name.search('Adobe Stock') !== -1) {
    dispatch(fetchAdobeStockContents(theme));
  } else if (theme.name.search('HP Mosaic') !== -1) {
    dispatch(fetchHPMosaicContents(theme, 1));
  }
};

export const setSearchContents = (mode, contents) => dispatch => {
  dispatch({
    type: actions.SET_SEARCH_CONTENTS,
    payload: { searchMode: mode, searchedContents: contents }
  });
};

export const getActiveTabThemesArray = () => (dispatch, getState) => {
  const tab = getState().sideBar.activeSideBarTab;
  if (tab === Constants.BACKGROUND_TAB_KEY) {
    return getState().modal.themesArray.scenesData;
  }
  if (tab === Constants.PHOTO_TAB_KEY) {
    return getState().modal.themesArray.photosData;
  }
  if (tab === Constants.ELEMENT_TAB_KEY) {
    return getState().modal.themesArray.elementsData;
  }
  return [];
};

export const fetchHostedContents = theme => dispatch => {
  dispatch(setLoadingState(string.LOADING_KEY));
  const folderThemes = [];
  if (theme.themes.length > 0) {
    dispatch(setLoadingState(null));
    getOneLevelPatterns(
      theme.themes,
      folderThemes,
      dispatch(getActiveTabThemesArray())
    );
    theme.folders = folderThemes;
    dispatch({
      type: actions.SET_FOLDER_LIST_ELEMENTS,
      payload: { folderListElements: theme }
    });
  } else if (theme.elements.length > 0) {
    dispatch(setLoadingState(null));
    dispatch({
      type: actions.SET_FOLDER_LIST_ELEMENTS,
      payload: { folderListElements: theme }
    });
  } else {
    const themeId = theme.hostedContentThemeId
      ? theme.hostedContentThemeId
      : theme.id;
    api
      .getHostedContents(themeId)
      .then(res => {
        theme.themes = createResponseObject(
          res.data.data.child_themes,
          Constants.CHILD_THEME_KEY
        );

        dispatch(generateHostedContent(theme.themes));

        getOneLevelPatterns(
          theme.themes,
          folderThemes,
          dispatch(getActiveTabThemesArray())
        );
        if (folderThemes.length > 0) {
          theme.folders = folderThemes;
        }

        dispatch(setLoadingState(null));

        dispatch({
          type: actions.SET_FOLDER_LIST_ELEMENTS,
          payload: { folderListElements: theme }
        });
      })
      .catch(err => {
        dispatch(setLoadingState(null));
        if (err) {
          const dict = {
            header: '',
            description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
            stringColor: Constants.DEFAULT_STRING_COLOR,
            onclick: null,
            buttonTitles: {
              finish: string.OK_KEY,
              cancel: ''
            }
          };
          dispatch(setMessageDialogParams(dict));
        }
      });
  }
  dispatch(setShouldLoadMoreContents(false));
};

export const generateHostedContent = childThemes => (dispatch, getState) => {
  if (childThemes) {
    const tab = getState().sideBar.activeSideBarTab;
    childThemes.forEach(childTheme => {
      const contentsPerType = [];
      let isValidItem = false;
      if (childTheme.contents.length) {
        childTheme.contents.forEach(item => {
          if (
            (tab === Constants.BACKGROUND_TAB_KEY &&
              item.userPhotoType == Constants.USER_PHOTO_SCENE_TYPE) ||
            (tab === Constants.PHOTO_TAB_KEY &&
              item.userPhotoType == Constants.USER_PHOTO_ELEMENT_TYPE &&
              item.isPhoto) ||
            (tab === Constants.ELEMENT_TAB_KEY &&
              item.userPhotoType == Constants.USER_PHOTO_ELEMENT_TYPE &&
              !item.isPhoto)
          ) {
            isValidItem = true;
          }
          if (isValidItem) {
            contentsPerType.push(item);
          }
          item.themeId = childTheme.id;
          item.themeName = childTheme.name;
        });
        const array = dispatch(getActiveTabThemesArray());
        if (contentsPerType.length > 0) {
          array.push({
            id: childTheme.id,
            name: childTheme.name,
            parentId: childTheme.parentId,
            themes: childTheme.childThemes,
            elements: contentsPerType,
            sampleContents: contentsPerType,
            hostedContent: true
          });
        }
      }
      dispatch(generateHostedContent(childTheme.childThemes));
    });
  }
};

const fetchPatternContents = theme => (dispatch, getState) => {
  dispatch(setLoadingState(string.LOADING_KEY));
  const folderThemes = [];
  if (
    theme.elements.length === 0 &&
    theme.themes.length === 0 &&
    (theme.name.search('Pattern Design') !== -1 ||
      (Object.prototype.hasOwnProperty.call(theme, 'containsPatterns') &&
        !theme.containsPatterns))
  ) {
    let searchCategoryId = null;
    if (theme.name.search('Pattern Design') === -1) {
      searchCategoryId = theme.id;
    }
    api
      .getPatternDesignContents(searchCategoryId)

      .then(res => {
        const responseData = res.data.categories;
        theme.themes = responseData;
        generatePatternData(responseData, theme.id, theme.id, getState);

        getOneLevelPatterns(
          theme.themes,
          folderThemes,
          getState().modal.themesArray.scenesData
        );
        theme.folders = folderThemes;

        dispatch(setLoadingState(null));

        dispatch({
          type: actions.SET_FOLDER_LIST_ELEMENTS,
          payload: { folderListElements: theme }
        });
      })
      .catch(err => {
        dispatch(setLoadingState(null));
        if (err) {
          const dict = {
            header: '',
            description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
            stringColor: Constants.DEFAULT_STRING_COLOR,
            onclick: null,
            buttonTitles: {
              finish: string.OK_KEY,
              cancel: ''
            }
          };
          dispatch(setMessageDialogParams(dict));
        }
      });
  } else {
    dispatch(setLoadingState(null));

    const folderThemes2 = [];
    if (theme.themes.length > 0) {
      getOneLevelPatterns(
        theme.themes,
        folderThemes2,
        getState().modal.themesArray.scenesData
      );
      theme.folders = folderThemes2;
      dispatch({
        type: actions.SET_FOLDER_LIST_ELEMENTS,
        payload: { folderListElements: theme }
      });
    } else {
      dispatch(setLoadingState(string.LOADING_KEY));
      searchForPatterns(theme, theme.id, null, null, 0, dispatch, getState);
    }
  }
  dispatch(setShouldLoadMoreContents(false));
};

export const searchForPatterns = (
  theme,
  categoryId,
  color,
  text,
  inOffset,
  dispatch,
  getState
) => {
  let offset = inOffset;
  const textRequest = text
    ? encodeURIComponent(text)
    : encodeURIComponent(null);
  api
    .searchForPatterns(categoryId, color, textRequest, offset)
    .then(res => {
      dispatch(setLoadingState(null));
      let responseData = res.data.patterns;
      if (responseData === null) {
        responseData = [];
        offset = offset == 0 ? 1 : offset;
        dispatch(
          showErrorDialog(Constants.PATTERN_DESIGN_IMAGE_SOURCE, offset)
        );
      } else if (responseData.length === 0) {
        const tempOffset = offset == 0 ? 1 : offset;
        dispatch(setShouldLoadMoreContents(true));
        dispatch(
          showErrorDialog(Constants.PATTERN_DESIGN_IMAGE_SOURCE, tempOffset)
        );
        dispatch(setShowLoading(false));
        return;
      } else {
        dispatch(setShouldLoadMoreContents(true));
        if (getState().sideBar.isMaximumLimit) {
          dispatch(setIsMaximumLimit(false));
        }
      }
      const smaplePatternsArray = generateSamplePatternsArray(
        responseData,
        theme.id,
        theme.name
      );

      let searchedContentsArray;
      // if offset is zero condition.....
      if (offset / 30 !== 0) {
        searchedContentsArray = getState().sideBar.searchedContents;

        searchedContentsArray = searchedContentsArray.concat(
          smaplePatternsArray
        );
      } else {
        searchedContentsArray = smaplePatternsArray;
      }
      if (categoryId === null) {
        dispatch(setSearchContents(true, searchedContentsArray));
      } else {
        // categoryID is not null for loadMoreContents flow thereby updating the lists.
        if (theme.elements) {
          dispatch(setSearchContents(true, searchedContentsArray));
        } else {
          theme.elements = smaplePatternsArray;
        }
        dispatch({
          type: actions.SET_FOLDER_LIST_ELEMENTS,
          payload: { folderListElements: theme }
        });
      }
      dispatch(setShowLoading(false));
    })
    .catch(() => {
      dispatch(setLoadingState(null));
      dispatch(setShowLoading(false));
      const dict = {
        header: '',
        description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
        stringColor: Constants.DEFAULT_STRING_COLOR,
        onclick: null,
        buttonTitles: {
          finish: string.OK_KEY,
          cancel: ''
        }
      };
      dispatch(setMessageDialogParams(dict));
    });
};

const generateSamplePatternsArray = (
  inputSamplePatterns,
  patternDesignId,
  themeName
) => {
  const samplePatterns = createResponseObject(
    inputSamplePatterns,
    Constants.USER_PHOTO_TYPE,
    Constants.PATTERN_DESIGN_IMAGE_SOURCE
  );
  samplePatterns.forEach(samplePattern => {
    samplePattern.themeId = patternDesignId;
    samplePattern.themeName = themeName;
  });
  return samplePatterns;
};

export const generatePatternData = (
  responseData,
  parentId,
  patternDesignId,
  getState
) => {
  responseData.forEach(category => {
    const smaplePatternsArray = generateSamplePatternsArray(
      category.samplePatterns,
      category.id,
      category.title
    );

    getState().modal.themesArray.scenesData.push({
      id: category.id,
      name: category.title,
      parentId,
      themes: Object.prototype.hasOwnProperty.call(category, 'categories')
        ? category.categories
        : [],
      thumbnailath: category.thumbnail,
      elements: [],
      samplePatterns: smaplePatternsArray,
      containsPatterns: category.containsPatterns,
      isPremium: true
    });

    if (Object.prototype.hasOwnProperty.call(category, 'categories')) {
      generatePatternData(
        category.categories,
        category.id,
        patternDesignId,
        getState
      );
    }
  });
};

export const fetchUnsplashContents = theme => (dispatch, getState) => {
  dispatch(setLoadingState(string.LOADING_KEY));
  if (getState().modal.unsplashPlaceholder === null) {
    api
      .getUnsplashContents(encodeURIComponent(null), 1)

      .then(res => {
        const unsplashArray = dispatch(generateUnsplashArray(res.data, theme));
        theme.elements = unsplashArray;
        dispatch({
          type: actions.SET_UNSPLASH_PLACEHOLDER,
          payload: { unsplashPlaceholder: unsplashArray }
        });
        dispatch({
          type: actions.FETCH_UNSPLASH_CONTENTS,
          payload: { unsplashData: unsplashArray }
        });
        dispatch({
          type: actions.SET_FOLDER_LIST_ELEMENTS,
          payload: { folderListElements: theme }
        });

        dispatch(setLoadingState(null));
      })

      .catch(err => {
        dispatch(setLoadingState(null));
        if (err) {
          const dict = {
            header: '',
            description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
            stringColor: Constants.DEFAULT_STRING_COLOR,
            onclick: null,
            buttonTitles: {
              finish: string.OK_KEY,
              cancel: ''
            }
          };
          dispatch(setMessageDialogParams(dict));
        }
      });
  } else {
    const unsplashData = getState().modal.unsplashPlaceholder;
    theme.elements = unsplashData;
    dispatch({
      type: actions.FETCH_UNSPLASH_CONTENTS,
      payload: { unsplashData }
    });
    dispatch({
      type: actions.SET_FOLDER_LIST_ELEMENTS,
      payload: { folderListElements: theme }
    });
    dispatch(setSearchContents(false, null));

    dispatch(setLoadingState(null));
    if (getState().sideBar.isMaximumLimit) {
      dispatch(setIsMaximumLimit(false));
    }
  }
  dispatch(setShouldLoadMoreContents(false));
};

const generateUnsplashArray = (inputUnsplashArray, theme) => dispatch => {
  const outputUnsplashArray = createResponseObject(
    inputUnsplashArray,
    Constants.USER_PHOTO_TYPE,
    Constants.UNSPLASH_IMAGE_SOURCE
  );
  outputUnsplashArray.forEach(item => {
    item.themeId = theme.id;
    item.themeName = theme.name;
  });
  dispatch(setContentsUserPhotoType(outputUnsplashArray));
  return outputUnsplashArray;
};

export const searchForUnsplash = (
  theme,
  text,
  count,
  page,
  dispatch,
  getState
) => {
  api
    .getUnsplashContents(encodeURIComponent(text), page)
    .then(res => {
      dispatch(setLoadingState(null));
      let responseData = res.data;
      if (encodeURIComponent(text) !== 'null') {
        responseData = res.data.results;
      }
      if (responseData === null) {
        responseData = [];
        dispatch(showErrorDialog(Constants.UNSPLASH_IMAGE_SOURCE, page));
      } else if (responseData.length === 0) {
        dispatch(setShouldLoadMoreContents(false));
        dispatch(showErrorDialog(Constants.UNSPLASH_IMAGE_SOURCE, page));
      } else if (getState().sideBar.isMaximumLimit) {
        dispatch(setIsMaximumLimit(false));
      }

      const unsplashArray =
        text != null
          ? dispatch(generateUnsplashArray(responseData, theme))
          : dispatch(generateUnsplashArray(res.data, theme));
      let searchedContentsArray = getState().sideBar.unsplashData;

      if (searchedContentsArray.length !== 0 && page !== 1) {
        searchedContentsArray = searchedContentsArray.concat(unsplashArray);
      } else {
        searchedContentsArray = unsplashArray;
      }
      if (text !== null) {
        dispatch(setSearchContents(true, searchedContentsArray));
        dispatch(setShouldLoadMoreContents(true));
      } else {
        // text is not null for loadMoreContents flow thereby updating the lists.
        if (theme.elements) {
          dispatch(setSearchContents(true, searchedContentsArray));
        } else {
          theme.elements = unsplashArray;
        }

        dispatch({
          type: actions.SET_FOLDER_LIST_ELEMENTS,
          payload: { folderListElements: theme }
        });
        dispatch(setShouldLoadMoreContents(false));
      }
      dispatch({
        type: actions.FETCH_UNSPLASH_CONTENTS,
        payload: { unsplashData: searchedContentsArray }
      });
      dispatch(setShowLoading(false));
    })
    .catch(() => {
      dispatch(setLoadingState(null));
      dispatch(setShowLoading(false));

      const dict = {
        header: '',
        description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
        stringColor: Constants.DEFAULT_STRING_COLOR,
        onclick: null,
        buttonTitles: {
          finish: string.OK_KEY,
          cancel: ''
        }
      };
      dispatch(setMessageDialogParams(dict));
    });
};

export const getNextInspirationsList = (
  offset,
  perPage,
  category,
  moreInspirationsCheck
) => (dispatch, getState) => {
  dispatch(
    getInspirations(
      offset,
      perPage,
      category,
      moreInspirationsCheck,
      getState().sideBar.inspirations
    )
  );
};

export const getInspirations = (
  offset,
  perPage,
  category,
  callback,
  currentList
) => (dispatch, getState) => {
  dispatch(setShowLoading(true));
  const { language } = getState().home;
  const { envData, storeData } = getState().modal;
  let inspirationGroupArray = [];
  let moreInspirationNeeded = false;

  const updatedList = {};
  updatedList.portraitInsp = currentList.portraitInspirations;
  updatedList.landscapeInsp = currentList.landscapeInspirations;

  let preference = null;
  if (!envData.is_vanilla_designer) {
    preference = storeData.templatePreference;
  }
  api
    .getInspirations(
      offset,
      perPage,
      category,
      language,
      preference,
      envData.store_token
    )
    .then(res => {
      if (res.status === 200) {
        const dataJson = res.data;

        if (dataJson.length > 0) {
          for (let i = 0; i < dataJson.length; i++) {
            let inspirationsArray = [];
            for (let j = 0; j < dataJson[i].length; j++) {
              const newTemplateElement = { previewImage: null, dataJSON: null };
              if (newTemplateElement) {
                const json = dataJson[i][j];
                newTemplateElement.dataJSON = json;
                newTemplateElement.previewImage = json.preview_image;
              }
              if (inspirationsArray !== []) {
                inspirationsArray.push(newTemplateElement);
              } else {
                inspirationsArray = newTemplateElement;
              }
            }

            if (inspirationGroupArray !== []) {
              inspirationGroupArray.push(inspirationsArray);
            } else {
              inspirationGroupArray = inspirationsArray;
            }
          }
          dispatch(setIsMaximumLimit(false));
          if (!updatedList.portraitInsp.length) {
            moreInspirationNeeded = true;
          }
        } else {
          dispatch(setIsMaximumLimit(true));
          dispatch(setShowLoading(false));
          dispatch(showErrorDialogueForInspiration(offset));
        }
        const dict = filterInspirations(inspirationGroupArray);
        updatedList.portraitInsp = updatedList.portraitInsp.concat(
          dict.portraitInsp
        );
        updatedList.landscapeInsp = updatedList.landscapeInsp.concat(
          dict.landInsp
        );
        dispatch({
          type: actions.SET_INSPIRATIONS,
          payload: {
            portraitInspirations: updatedList.portraitInsp,
            landscapeInspirations: updatedList.landscapeInsp
          }
        });
        dispatch(setShowLoading(false));
        if (moreInspirationNeeded) {
          dispatch(setShouldLoadMoreContents(true));
        }
      } else {
        dispatch(setShowLoading(false));
        dispatch(setIsMaximumLimit(false));
        dispatch(showErrorDialogueForInspiration(null));
      }
    })
    .catch(() => {
      dispatch(setShowLoading(false));
      dispatch(setLoadingState(null));
    });
};

const filterInspirations = inGroupInspirations => {
  let tempLandscapeInspirations = [];
  let tempPortraitInspirations = [];

  for (let i = inGroupInspirations.length - 1; i >= 0; i--) {
    const individualArray = inGroupInspirations[i];
    let individualPortraitArray = [];
    let individualLandscapeArray = [];

    let landscapeTick = false;
    let portraitTick = false;
    for (let j = 0; j < individualArray.length; j++) {
      const inspiration = individualArray[j];
      const JSONObj = JSON.parse(JSON.stringify(inspiration.dataJSON));

      if (JSONObj.width >= JSONObj.height && !landscapeTick) {
        landscapeTick = true;
        // individualLandscapeArray !== []
        individualLandscapeArray = individualLandscapeArray.concat(inspiration);
        // : (individualLandscapeArray = inspiration);
      }

      if (JSONObj.width <= JSONObj.height && !portraitTick) {
        portraitTick = true;

        // individualPortraitArray !== []
        // ?
        individualPortraitArray = individualPortraitArray.concat(inspiration);
        // : (individualPortraitArray = inspiration);
      }
    }
    if (individualLandscapeArray.length > 0) {
      // tempLandscapeInspirations !== []
      // ?
      tempLandscapeInspirations = tempLandscapeInspirations.concat(
        individualLandscapeArray
      );
      // : (tempLandscapeInspirations = individualLandscapeArray);
    }

    if (individualPortraitArray.length > 0) {
      // tempPortraitInspirations !== []
      // ?
      tempPortraitInspirations = tempPortraitInspirations.concat(
        individualPortraitArray
      );
      // : (tempPortraitInspirations = individualPortraitArray);
    }
    if (!landscapeTick) {
      // tempLandscapeInspirations !== []
      // ?
      tempLandscapeInspirations = tempLandscapeInspirations.concat(
        individualPortraitArray
      );
      // : (tempLandscapeInspirations = individualPortraitArray);
    }
    if (!portraitTick) {
      // tempPortraitInspirations !== []
      // ?
      tempPortraitInspirations = tempPortraitInspirations.concat(
        individualLandscapeArray
      );
      // : (tempPortraitInspirations = individualLandscapeArray);
    }
    // inGroupInspirations removeObject:individualArray]

    inGroupInspirations.slice(individualArray);
  }
  const arr1 = reverseArray(tempPortraitInspirations);
  const arr2 = reverseArray(tempLandscapeInspirations);

  const dict = {};
  dict.portraitInsp = arr1;
  dict.landInsp = arr2;
  return dict;
};

export const reverseArray = inArray => {
  let reversedArray = [];
  for (let i = inArray.length - 1; i >= 0; i--) {
    reversedArray = reversedArray.concat(inArray[i]);
  }
  return reversedArray;
};

// to redraw component on updating price or Info
export const triggerRedrawAfterDataFetch = () => dispatch => {
  dispatch({
    type: actions.TRIGGER_COMPONENT_REDRAW
  });
};

export const showErrorDialog = (type, index) => dispatch => {
  dispatch(setIsMaximumLimit(true));
  let title = '';
  let key = '';
  let message = '';
  switch (type) {
    case Constants.UNSPLASH_IMAGE_SOURCE:
      title = string.UNSPLASH_SEARCH_TITLE;
      key = string.NO_ELEMENT_ERROR_MESSAGE;
      break;
    case Constants.VECTEEZY_IMAGE_SOURCE:
      title = string.VECTEEZY_SEARCH_TITLE;
      key = string.NO_ELEMENT_ERROR_MESSAGE;
      break;
    case Constants.PATTERN_DESIGN_IMAGE_SOURCE:
      title = string.PATTERN_DESIGN_TITLE_KEY;
      key = string.NO_PATTERN_ERROR_MESSAGE;
      break;
    case Constants.DREAMSTIME_IMAGE_SOURCE:
      title = string.DREAMSTIME_SEARCH_TITLE;
      key = string.NO_DREAMSTIME_ERROR_MESSAGE;
      break;
    case Constants.GETTY_IMAGE_SOURCE:
      title = string.GETTY_IMAGE_SEARCH_TITLE;
      key = string.NO_ELEMENT_ERROR_MESSAGE;
      break;
    case Constants.I_STOCK_IMAGE_SOURCE:
      title = string.I_STOCK_SEARCH_TITLE;
      key = string.NO_ELEMENT_ERROR_MESSAGE;
      break;
    case Constants.ADOBE_STOCK_IMAGE_SOURCE:
      title = string.ADOBE_STOCK_SEARCH_TITLE;
      key = string.NO_ELEMENT_ERROR_MESSAGE;
      break;
    case Constants.HP_MOSAIC_IMAGE_SOURCE:
      title = string.HP_MOSAIC_SEARCH_TITLE;
      key = string.NO_ELEMENT_ERROR_MESSAGE;
      break;

    default:
      title = string.SEARCH_TITLE;
      break;
  }
  if (index == 1) {
    message = key;
  } else {
    message = string.NO_MORE_IMAGES_FOUND_KEY;
  }

  const dict = {
    header: title,
    description: message,
    stringColor: Constants.DEFAULT_STRING_COLOR,
    onclick: () => dispatch(setIsMaximumLimit(false)),
    buttonTitles: { finish: string.OK_KEY, cancel: '' }
  };

  dispatch(setMessageDialogParams(dict));
};

export const showErrorDialogueForInspiration = offset => (
  dispatch,
  getState
) => {
  const { storeData, envData } = getState().modal;
  let message = '';
  if (
    offset == 0 &&
    (envData.is_vanilla_designer ||
      storeData.templatePreference.toLowerCase() == 'hp')
  ) {
    message = string.BLANK_INSPIRATION_CATEGORY_KEY;
  } else if (offset == null) {
    message = string.ERROR_DIALOG_VIEW_MESSAGE_TEXT;
  }

  if (message != '') {
    const dict = {
      header: '',
      description: message,
      stringColor: Constants.DEFAULT_STRING_COLOR,
      onclick: () => dispatch(setIsMaximumLimit(false)),
      buttonTitles: { finish: string.OK_KEY, cancel: '' }
    };
    dispatch(setMessageDialogParams(dict));
  }
  dispatch(setIsMaximumLimit(true));
};

export const checkForActiveTab = getState => {
  let type = '';
  const tab = getState().sideBar.activeSideBarTab;
  if (tab === Constants.BACKGROUND_TAB_KEY) {
    type = Constants.BACKGROUNDS_KEY;
  } else if (tab === Constants.PHOTO_TAB_KEY) {
    type = Constants.PHOTOS_KEY;
  } else if (tab === Constants.ELEMENT_TAB_KEY) {
    type = Constants.OBJECTS_TYPE;
  }
  return type;
};

export const fetchDreamstimeContents = theme => (dispatch, getState) => {
  const type = checkForActiveTab(getState);
  dispatch(setLoadingState(string.LOADING_KEY));
  api
    .getEditorsChoiceImages(type, 1, Constants.DREAMSTIME_PAGE_COUNT)
    .then(res => {
      if (res.status == 200) {
        const dreamstimeDict = res.data.Images;

        // if (Object.keys(dreamstimeDict).length === 0) {
        //   dispatch(showErrorDialog(Constants.DREAMSTIME_IMAGE_SOURCE));
        //   dispatch(setShouldLoadMoreContents(false));
        // } else {
        //   dispatch(setIsMaximumLimit(false));
        // }

        const dreamstimeArrayRaw = Object.values(dreamstimeDict);
        const dreamstimeArray = dispatch(
          generateDreamstimeArray(dreamstimeArrayRaw, theme)
        );

        theme.elements = dreamstimeArray;
        dispatch({
          type: actions.SET_FOLDER_LIST_ELEMENTS,
          payload: { folderListElements: theme }
        });
        dispatch({
          type: actions.FETCH_DREAMSTIME_CONTENTS,
          payload: { dreamstimeData: dreamstimeArray }
        });
      }
      dispatch(setSearchContents(false, null));
      if (getState().sideBar.isMaximumLimit) {
        dispatch(setIsMaximumLimit(false));
      }
      dispatch(setLoadingState(null));
    })
    .catch(err => {
      dispatch(setLoadingState(null));

      if (err) {
        const dict = {
          header: '',
          description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
          stringColor: Constants.DEFAULT_STRING_COLOR,
          onclick: null,
          buttonTitles: {
            finish: string.OK_KEY,
            cancel: ''
          }
        };
        dispatch(setMessageDialogParams(dict));
      }
    });
};
const setContentsUserPhotoType = array => (dispatch, getState) => {
  const activeTab = getState().sideBar.activeSideBarTab;

  array.forEach(item => {
    if (activeTab == Constants.BACKGROUND_TAB_KEY) {
      item.userPhotoType = Constants.USER_PHOTO_SCENE_TYPE;
    } else {
      item.userPhotoType = Constants.USER_PHOTO_ELEMENT_TYPE;
      if (activeTab == Constants.PHOTO_TAB_KEY) {
        item.isPhoto = true;
      } else {
        item.isPhoto = false;
      }
    }
  });
};

const generateDreamstimeArray = (inputDreamstimeArray, theme) => dispatch => {
  const outputDreamstimeArray = createResponseObject(
    inputDreamstimeArray,
    Constants.USER_PHOTO_TYPE,
    Constants.DREAMSTIME_IMAGE_SOURCE
  );
  outputDreamstimeArray.forEach(item => {
    item.themeId = theme.id;
    item.themeName = theme.name;
  });
  dispatch(setContentsUserPhotoType(outputDreamstimeArray));
  return outputDreamstimeArray;
};

export const searchForDreamstime = (
  theme,
  text,
  pageIndex,
  dispatch,
  getState
) => {
  const type = checkForActiveTab(getState);
  if (text !== null) {
    api
      .searchDreamstimeContents(
        encodeURIComponent(text),
        type,
        pageIndex,
        Constants.DREAMSTIME_PAGE_COUNT
      )
      .then(res => {
        dispatch(parseElements(res, theme, text, pageIndex));
      })
      .catch(() => {
        dispatch(setLoadingState(null));
        dispatch(setShowLoading(false));
        const dict = {
          header: '',
          description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
          stringColor: Constants.DEFAULT_STRING_COLOR,
          onclick: null,
          buttonTitles: {
            finish: string.OK_KEY,
            cancel: ''
          }
        };
        dispatch(setMessageDialogParams(dict));
      });
  } else {
    api
      .getEditorsChoiceImages(type, pageIndex, Constants.DREAMSTIME_PAGE_COUNT)
      .then(res => {
        dispatch(parseElements(res, theme, text, pageIndex));
        dispatch(setShouldLoadMoreContents(true));
      })
      .catch(() => {
        const dict = {
          header: '',
          description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
          stringColor: Constants.DEFAULT_STRING_COLOR,
          onclick: null,
          buttonTitles: {
            finish: string.OK_KEY,
            cancel: ''
          }
        };
        dispatch(setMessageDialogParams(dict));
      });
  }
};

const parseElements = (res, theme, text, pageIndex) => (dispatch, getState) => {
  dispatch(setLoadingState(null));
  const responseData = res.data.Images;

  if (Object.keys(responseData).length === 0) {
    dispatch(setShouldLoadMoreContents(false));
    dispatch(showErrorDialog(Constants.DREAMSTIME_IMAGE_SOURCE, pageIndex));
  } else if (getState().sideBar.isMaximumLimit) {
    dispatch(setIsMaximumLimit(false));
  }

  const dreamstimeArrayRaw = Object.values(responseData);
  const dreamstimeArray = dispatch(
    generateDreamstimeArray(dreamstimeArrayRaw, theme)
  );

  let searchedContentsArray = getState().sideBar.dreamstimeData;
  if (searchedContentsArray.length !== 0 && pageIndex !== 1) {
    searchedContentsArray = searchedContentsArray.concat(dreamstimeArray);
  } else {
    searchedContentsArray = dreamstimeArray;
  }

  if (text !== null) {
    dispatch(setSearchContents(true, searchedContentsArray));
    dispatch(setShouldLoadMoreContents(true));
  } else {
    // text is not null for loadMoreContents flow thereby updating the lists.
    if (theme.elements) {
      dispatch(setSearchContents(true, searchedContentsArray));
    } else {
      theme.elements = dreamstimeArray;
    }

    dispatch({
      type: actions.SET_FOLDER_LIST_ELEMENTS,
      payload: { folderListElements: theme }
    });
    dispatch(setShouldLoadMoreContents(false));
  }

  dispatch({
    type: actions.FETCH_DREAMSTIME_CONTENTS,
    payload: { dreamstimeData: searchedContentsArray }
  });
  dispatch(setShowLoading(false));
};

export const fetchGettyImageContents = theme => (dispatch, getState) => {
  dispatch(setLoadingState(string.LOADING_KEY));

  const { activeSideBarTab } = getState().sideBar;
  if (activeSideBarTab === Constants.BACKGROUND_TAB_KEY) {
    if (getState().modal.gettyImageBackgroundPlaceholder === null) {
      api
        .getGettyImageContents(
          Constants.BACKGROUND_TYPE,
          encodeURIComponent(null),
          1,
          getState().modal.storeData.id
        )
        .then(res => {
          const gettyImageArray = dispatch(
            generateGettyImageArray(res.data.images, theme)
          );

          theme.elements = gettyImageArray;

          dispatch({
            type: actions.SET_GETTY_IMAGE_BACKGROUND_PLACEHOLDER,
            payload: { gettyImageBackgroundPlaceholder: gettyImageArray }
          });
          dispatch({
            type: actions.FETCH_GETTY_IMAGE_BACKGROUND_CONTENTS,
            payload: { gettyImageBackgroundData: gettyImageArray }
          });
          dispatch(setLoadingState(null));
          if (getState().sideBar.isMaximumLimit) {
            dispatch(setIsMaximumLimit(false));
          }
        })
        .catch(err => {
          dispatch(setLoadingState(null));
          if (err) {
            const dict = {
              header: '',
              description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
              stringColor: Constants.DEFAULT_STRING_COLOR,
              onclick: null,
              buttonTitles: {
                finish: string.OK_KEY,
                cancel: ''
              }
            };
            dispatch(setMessageDialogParams(dict));
          }
        });
    } else {
      const BackgroundData = getState().modal.gettyImageBackgroundPlaceholder;

      theme.elements = BackgroundData;
      dispatch({
        type: actions.FETCH_GETTY_IMAGE_BACKGROUND_CONTENTS,
        payload: { gettyImageBackgroundData: BackgroundData }
      });
      dispatch(setSearchContents(false, null));
      dispatch(setLoadingState(null));
      if (getState().sideBar.isMaximumLimit) {
        dispatch(setIsMaximumLimit(false));
      }
    }
  } else if (activeSideBarTab === Constants.PHOTO_TAB_KEY) {
    if (getState().modal.gettyImagePhotosPlaceholder === null) {
      api
        .getGettyImageContents(
          Constants.PHOTOS_TYPE,
          encodeURIComponent(null),
          1,
          getState().modal.storeData.id
        )
        .then(res => {
          const gettyImageArray = dispatch(
            generateGettyImageArray(res.data.images, theme)
          );

          theme.elements = gettyImageArray;
          dispatch({
            type: actions.SET_GETTY_IMAGE_PHOTOS_PLACEHOLDER,
            payload: { gettyImagePhotosPlaceholder: gettyImageArray }
          });
          dispatch({
            type: actions.FETCH_GETTY_IMAGE_PHOTOS_CONTENTS,
            payload: { gettyImagePhotosData: gettyImageArray }
          });
          dispatch(setLoadingState(null));
          if (getState().sideBar.isMaximumLimit) {
            dispatch(setIsMaximumLimit(false));
          }
        })
        .catch(err => {
          dispatch(setLoadingState(null));
          if (err) {
            const dict = {
              header: '',
              description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
              stringColor: Constants.DEFAULT_STRING_COLOR,
              onclick: null,
              buttonTitles: {
                finish: string.OK_KEY,
                cancel: ''
              }
            };
            dispatch(setMessageDialogParams(dict));
          }
        });
    } else {
      const PhotosData = getState().modal.gettyImagePhotosPlaceholder;

      theme.elements = PhotosData;
      dispatch({
        type: actions.FETCH_GETTY_IMAGE_PHOTOS_CONTENTS,
        payload: { gettyImagePhotosData: PhotosData }
      });

      dispatch(setSearchContents(false, null));
      dispatch(setLoadingState(null));
      if (getState().sideBar.isMaximumLimit) {
        dispatch(setIsMaximumLimit(false));
      }
    }
  } else if (activeSideBarTab === Constants.ELEMENT_TAB_KEY) {
    if (getState().modal.gettyImageObjectsPlaceholder === null) {
      api
        .getGettyImageContents(
          Constants.OBJECTS_TYPE,
          encodeURIComponent(null),
          1,
          getState().modal.storeData.id
        )
        .then(res => {
          const gettyImageArray = dispatch(
            generateGettyImageArray(res.data.images, theme)
          );

          theme.elements = gettyImageArray;
          dispatch({
            type: actions.SET_GETTY_IMAGE_OBJECTS_PLACEHOLDER,
            payload: { gettyImageObjectsPlaceholder: gettyImageArray }
          });
          dispatch({
            type: actions.FETCH_GETTY_IMAGE_OBJECTS_CONTENTS,
            payload: { gettyImageObjectsData: gettyImageArray }
          });
          dispatch(setLoadingState(null));
          if (getState().sideBar.isMaximumLimit) {
            dispatch(setIsMaximumLimit(false));
          }
        })
        .catch(err => {
          dispatch(setLoadingState(null));

          if (err) {
            const dict = {
              header: '',
              description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
              stringColor: Constants.DEFAULT_STRING_COLOR,
              onclick: null,
              buttonTitles: {
                finish: string.OK_KEY,
                cancel: ''
              }
            };
            dispatch(setMessageDialogParams(dict));
          }
        });
    } else {
      const ObjectsData = getState().modal.gettyImageObjectsPlaceholder;

      theme.elements = ObjectsData;
      dispatch({
        type: actions.FETCH_GETTY_IMAGE_OBJECTS_CONTENTS,
        payload: { gettyImageObjectsData: ObjectsData }
      });

      dispatch(setSearchContents(false, null));
      dispatch(setLoadingState(null));
      if (getState().sideBar.isMaximumLimit) {
        dispatch(setIsMaximumLimit(false));
      }
    }
  }
  dispatch({
    type: actions.SET_FOLDER_LIST_ELEMENTS,
    payload: { folderListElements: theme }
  });
  dispatch({
    type: actions.SET_FOLDER_LIST_ELEMENTS,
    payload: { folderListElements: theme }
  });
  dispatch(setShouldLoadMoreContents(false));
};

const generateGettyImageArray = (inputGettyImageArray, theme) => (
  dispatch,
  getState
) => {
  const outputGettyImageArray = createResponseObject(
    inputGettyImageArray,
    Constants.USER_PHOTO_TYPE,
    Constants.GETTY_IMAGE_SOURCE
  );
  outputGettyImageArray.forEach(item => {
    item.themeId = theme.id;
    item.themeName = theme.name;
    item.costValue =
      getState().modal.storeData.basePricePerGettyImage +
      getState().modal.storeData.gettyImagesSubscriptionPrice;
  });
  dispatch(setContentsUserPhotoType(outputGettyImageArray));

  return outputGettyImageArray;
};

export const searchForGettyImage = (
  theme,
  text,
  count,
  page,
  dispatch,
  getState
) => {
  const type = checkForActiveTab(getState);
  api
    .getGettyImageContents(
      type,
      encodeURIComponent(text),
      page,
      getState().modal.storeData.id
    )
    .then(res => {
      dispatch(setLoadingState(null));
      const responseData = res.data.images;
      // if (encodeURIComponent(text) !== 'null') {
      //   responseData = res.data.images;
      // }
      const { activeSideBarTab } = getState().sideBar;
      if (res.data.result === Constants.FAILED) {
        dispatch(showErrorDialog(Constants.GETTY_IMAGE_SOURCE, page));
        dispatch(setShowLoading(false));
        return;
      }
      if (responseData.length === 0) {
        dispatch(showErrorDialog(Constants.GETTY_IMAGE_SOURCE, page));
        dispatch(setShouldLoadMoreContents(false));
      } else if (getState().sideBar.isMaximumLimit) {
        dispatch(setIsMaximumLimit(false));
      }

      const gettyImageArray = dispatch(
        generateGettyImageArray(res.data.images, theme)
      );

      let searchedContentsArray = [];
      if (activeSideBarTab === Constants.BACKGROUND_TAB_KEY) {
        searchedContentsArray = getState().sideBar.gettyImageBackgroundData;
      } else if (activeSideBarTab === Constants.PHOTO_TAB_KEY) {
        searchedContentsArray = getState().sideBar.gettyImagePhotosData;
      } else {
        searchedContentsArray = getState().sideBar.gettyImageObjectsData;
      }

      if (searchedContentsArray.length !== 0 && page !== 1) {
        searchedContentsArray = searchedContentsArray.concat(gettyImageArray);
      } else {
        searchedContentsArray = gettyImageArray;
      }

      if (text !== null) {
        dispatch(setSearchContents(true, searchedContentsArray));
        dispatch(setShouldLoadMoreContents(true));
      } else {
        // text is not null for loadMoreContents flow thereby updating the lists.
        if (theme.elements) {
          dispatch(setSearchContents(true, searchedContentsArray));
        } else {
          theme.elements = gettyImageArray;
        }

        dispatch({
          type: actions.SET_FOLDER_LIST_ELEMENTS,
          payload: { folderListElements: theme }
        });
        dispatch(setShouldLoadMoreContents(false));
      }

      if (activeSideBarTab === Constants.BACKGROUND_TAB_KEY) {
        dispatch({
          type: actions.FETCH_GETTY_IMAGE_BACKGROUND_CONTENTS,
          payload: { gettyImageBackgroundData: searchedContentsArray }
        });
      } else if (activeSideBarTab === Constants.PHOTO_TAB_KEY) {
        dispatch({
          type: actions.FETCH_GETTY_IMAGE_PHOTOS_CONTENTS,
          payload: { gettyImagePhotosData: searchedContentsArray }
        });
      } else if (activeSideBarTab === Constants.ELEMENT_TAB_KEY) {
        dispatch({
          type: actions.FETCH_GETTY_IMAGE_OBJECTS_CONTENTS,
          payload: { gettyImageObjectsData: searchedContentsArray }
        });
      }

      dispatch(setShowLoading(false));
    })
    .catch(() => {
      dispatch(setLoadingState(null));

      dispatch(setShowLoading(false));
      const dict = {
        header: '',
        description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
        stringColor: Constants.DEFAULT_STRING_COLOR,
        onclick: null,
        buttonTitles: {
          finish: string.OK_KEY,
          cancel: ''
        }
      };
      dispatch(setMessageDialogParams(dict));
    });
};

export const fetchIStockContents = theme => (dispatch, getState) => {
  dispatch(setLoadingState(string.LOADING_KEY));
  const { activeSideBarTab } = getState().sideBar;
  if (activeSideBarTab === Constants.BACKGROUND_TAB_KEY) {
    if (getState().modal.iStockBackgroundPlaceholder === null) {
      api
        .getIStockContents(
          Constants.BACKGROUND_TYPE,
          encodeURIComponent(null),
          1,
          getState().modal.storeData.id
        )
        .then(res => {
          const iStockArray = dispatch(
            generateIStockArray(res.data.images, theme)
          );

          theme.elements = iStockArray;

          dispatch({
            type: actions.SET_I_STOCK_BACKGROUND_PLACEHOLDER,
            payload: { iStockBackgroundPlaceholder: iStockArray }
          });
          dispatch({
            type: actions.FETCH_I_STOCK_BACKGROUND_CONTENTS,
            payload: { iStockBackgroundData: iStockArray }
          });
          dispatch(setLoadingState(null));
          if (getState().sideBar.isMaximumLimit) {
            dispatch(setIsMaximumLimit(false));
          }
        })
        .catch(err => {
          dispatch(setLoadingState(null));
          if (err) {
            const dict = {
              header: '',
              description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
              stringColor: Constants.DEFAULT_STRING_COLOR,
              onclick: null,
              buttonTitles: {
                finish: string.OK_KEY,
                cancel: ''
              }
            };
            dispatch(setMessageDialogParams(dict));
          }
        });
    } else {
      const BackgroundData = getState().modal.iStockBackgroundPlaceholder;
      theme.elements = BackgroundData;
      dispatch({
        type: actions.FETCH_I_STOCK_BACKGROUND_CONTENTS,
        payload: { iStockBackgroundData: BackgroundData }
      });
      dispatch(setSearchContents(false, null));
      dispatch(setLoadingState(null));
      if (getState().sideBar.isMaximumLimit) {
        dispatch(setIsMaximumLimit(false));
      }
    }
  } else if (activeSideBarTab === Constants.PHOTO_TAB_KEY) {
    if (getState().modal.iStockPhotosPlaceholder === null) {
      api
        .getIStockContents(
          Constants.PHOTOS_TYPE,
          encodeURIComponent(null),
          1,
          getState().modal.storeData.id
        )
        .then(res => {
          const iStockArray = dispatch(
            generateIStockArray(res.data.images, theme)
          );

          theme.elements = iStockArray;

          dispatch({
            type: actions.SET_I_STOCK_PHOTOS_PLACEHOLDER,
            payload: { iStockPhotosPlaceholder: iStockArray }
          });
          dispatch({
            type: actions.FETCH_I_STOCK_PHOTOS_CONTENTS,
            payload: { iStockPhotosData: iStockArray }
          });
          dispatch(setLoadingState(null));
          if (getState().sideBar.isMaximumLimit) {
            dispatch(setIsMaximumLimit(false));
          }
        })
        .catch(err => {
          dispatch(setLoadingState(null));

          if (err) {
            const dict = {
              header: '',
              description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
              stringColor: Constants.DEFAULT_STRING_COLOR,
              onclick: null,
              buttonTitles: {
                finish: string.OK_KEY,
                cancel: ''
              }
            };
            dispatch(setMessageDialogParams(dict));
          }
        });
    } else {
      const PhotosData = getState().modal.iStockPhotosPlaceholder;
      theme.elements = PhotosData;
      dispatch({
        type: actions.FETCH_I_STOCK_PHOTOS_CONTENTS,
        payload: { iStockPhotosData: PhotosData }
      });
      dispatch(setSearchContents(false, null));
      dispatch(setLoadingState(null));
      if (getState().sideBar.isMaximumLimit) {
        dispatch(setIsMaximumLimit(false));
      }
    }
  } else if (activeSideBarTab === Constants.ELEMENT_TAB_KEY) {
    if (getState().modal.iStockObjectsPlaceholder === null) {
      api
        .getIStockContents(
          Constants.OBJECTS_TYPE,
          encodeURIComponent(null),
          1,
          getState().modal.storeData.id
        )
        .then(res => {
          const iStockArray = dispatch(
            generateIStockArray(res.data.images, theme)
          );

          theme.elements = iStockArray;

          dispatch({
            type: actions.SET_I_STOCK_OBJECTS_PLACEHOLDER,
            payload: { iStockObjectsPlaceholder: iStockArray }
          });
          dispatch({
            type: actions.FETCH_I_STOCK_OBJECTS_CONTENTS,
            payload: { iStockObjectsData: iStockArray }
          });
          dispatch(setLoadingState(null));
          if (getState().sideBar.isMaximumLimit) {
            dispatch(setIsMaximumLimit(false));
          }
        })
        .catch(err => {
          dispatch(setLoadingState(null));

          if (err) {
            const dict = {
              header: '',
              description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
              stringColor: Constants.DEFAULT_STRING_COLOR,
              onclick: null,
              buttonTitles: {
                finish: string.OK_KEY,
                cancel: ''
              }
            };
            dispatch(setMessageDialogParams(dict));
          }
        });
    } else {
      const ObjectsData = getState().modal.iStockObjectsPlaceholder;
      theme.elements = ObjectsData;
      dispatch({
        type: actions.FETCH_I_STOCK_OBJECTS_CONTENTS,
        payload: { iStockObjectsData: ObjectsData }
      });
      dispatch(setSearchContents(false, null));
      dispatch(setLoadingState(null));
      if (getState().sideBar.isMaximumLimit) {
        dispatch(setIsMaximumLimit(false));
      }
    }
  }

  dispatch({
    type: actions.SET_FOLDER_LIST_ELEMENTS,
    payload: { folderListElements: theme }
  });
  dispatch(setShouldLoadMoreContents(false));
};

const generateIStockArray = (inputIStockArray, theme) => (
  dispatch,
  getState
) => {
  const outputIStockArray = createResponseObject(
    inputIStockArray,
    Constants.USER_PHOTO_TYPE,
    Constants.I_STOCK_IMAGE_SOURCE
  );
  outputIStockArray.forEach(item => {
    item.themeId = theme.id;
    item.themeName = theme.name;
    item.costValue =
      getState().modal.storeData.basePricePerIstockImage +
      getState().modal.storeData.istockSubscriptionPrice;
  });
  dispatch(setContentsUserPhotoType(outputIStockArray));

  return outputIStockArray;
};

export const searchForIStock = (
  theme,
  text,
  count,
  page,
  dispatch,
  getState
) => {
  const type = checkForActiveTab(getState);
  api

    .getIStockContents(
      type,
      encodeURIComponent(text),
      page,
      getState().modal.storeData.id
    )
    .then(res => {
      dispatch(setLoadingState(null));
      const responseData = res.data.images;
      // if (encodeURIComponent(text) !== 'null') {
      //   responseData = res.data.images;
      // }
      const { activeSideBarTab } = getState().sideBar;
      if (res.data.result === Constants.FAILED) {
        dispatch(showErrorDialog(Constants.I_STOCK_IMAGE_SOURCE, page));
        dispatch(setShowLoading(false));
        return;
      }
      if (responseData.length === 0) {
        dispatch(showErrorDialog(Constants.I_STOCK_IMAGE_SOURCE, page));
        dispatch(setShouldLoadMoreContents(false));
      } else {
        dispatch(setIsMaximumLimit(false));
      }

      const iStockArray = dispatch(generateIStockArray(res.data.images, theme));
      let searchedContentsArray = [];
      if (activeSideBarTab === Constants.BACKGROUND_TAB_KEY) {
        searchedContentsArray = getState().sideBar.iStockBackgroundData;
      } else if (activeSideBarTab === Constants.PHOTO_TAB_KEY) {
        searchedContentsArray = getState().sideBar.iStockPhotosData;
      } else {
        searchedContentsArray = getState().sideBar.iStockObjectsData;
      }

      if (searchedContentsArray.length !== 0 && page !== 1) {
        searchedContentsArray = searchedContentsArray.concat(iStockArray);
      } else {
        searchedContentsArray = iStockArray;
      }

      if (text !== null) {
        dispatch(setSearchContents(true, searchedContentsArray));
        dispatch(setShouldLoadMoreContents(true));
      } else {
        // text is not null for loadMoreContents flow thereby updating the lists.
        if (theme.elements) {
          dispatch(setSearchContents(true, searchedContentsArray));
        } else {
          theme.elements = iStockArray;
        }

        dispatch({
          type: actions.SET_FOLDER_LIST_ELEMENTS,
          payload: { folderListElements: theme }
        });
        dispatch(setShouldLoadMoreContents(false));
      }

      if (activeSideBarTab === Constants.BACKGROUND_TAB_KEY) {
        dispatch({
          type: actions.FETCH_I_STOCK_BACKGROUND_CONTENTS,
          payload: { iStockBackgroundData: searchedContentsArray }
        });
      } else if (activeSideBarTab === Constants.PHOTO_TAB_KEY) {
        dispatch({
          type: actions.FETCH_I_STOCK_PHOTOS_CONTENTS,
          payload: { iStockPhotosData: searchedContentsArray }
        });
      } else if (activeSideBarTab === Constants.ELEMENT_TAB_KEY) {
        dispatch({
          type: actions.FETCH_I_STOCK_OBJECTS_CONTENTS,
          payload: { iStockObjectsData: searchedContentsArray }
        });
      }

      dispatch(setShowLoading(false));
    })
    .catch(() => {
      dispatch(setLoadingState(null));
      dispatch(setShowLoading(false));
      const dict = {
        header: '',
        description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
        stringColor: Constants.DEFAULT_STRING_COLOR,
        onclick: null,
        buttonTitles: {
          finish: string.OK_KEY,
          cancel: ''
        }
      };
      dispatch(setMessageDialogParams(dict));
    });
};

export const handleBottomBarClick = state => dispatch => {
  const className = state ? 'pointer-event-null' : '';
  dispatch({
    type: actions.HANDLE_BOTTOM_BREADCRUMB_CLICK,
    payload: { value: className }
  });
};

export const getPremiumContentFolderTitle = imageSource => {
  if (imageSource === Constants.PATTERN_DESIGN_IMAGE_SOURCE) {
    return Constants.PATTERN_DESIGN_TITLE;
  }
  if (imageSource === Constants.DREAMSTIME_IMAGE_SOURCE) {
    return Constants.DREAMSTIME;
  }
  return '';
};

export const fetchAdobeStockContents = theme => (dispatch, getState) => {
  const type = checkForActiveTab(getState);
  const { language } = getState().home;
  dispatch(setLoadingState(string.LOADING_KEY));
  api
    .searchForAdobeStockContents(language, type, null, 1, 'popular')
    .then(res => {
      if (res.status == 200) {
        const adobeStockDict = res.data.files;

        // if (Object.keys(dreamstimeDict).length === 0) {
        //   dispatch(showErrorDialog(Constants.DREAMSTIME_IMAGE_SOURCE));
        //   dispatch(setShouldLoadMoreContents(false));
        // } else {
        //   dispatch(setIsMaximumLimit(false));
        // }

        // let dreamstimeArrayRaw = Object.values(dreamstimeDict);
        const adobeStockArray = dispatch(
          generateAdobeStockArray(adobeStockDict, theme)
        );

        theme.elements = adobeStockArray;
        dispatch({
          type: actions.SET_FOLDER_LIST_ELEMENTS,
          payload: { folderListElements: theme }
        });
        dispatch({
          type: actions.FETCH_ADOBE_STOCK_CONTENTS,
          payload: { adobeStockData: adobeStockArray }
        });
      }
      dispatch(setSearchContents(false, null));
      if (getState().sideBar.isMaximumLimit) {
        dispatch(setIsMaximumLimit(false));
      }
      dispatch(setLoadingState(null));
    })
    .catch(err => {
      dispatch(setLoadingState(null));

      if (err) {
        const dict = {
          header: '',
          description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
          stringColor: Constants.DEFAULT_STRING_COLOR,
          onclick: null,
          buttonTitles: {
            finish: string.OK_KEY,
            cancel: ''
          }
        };
        dispatch(setMessageDialogParams(dict));
      }
    });
};

export const searchForAdobeStock = (
  theme,
  text,
  pageIndex,
  dispatch,
  getState
) => {
  const type = checkForActiveTab(getState);
  const { language } = getState().home;
  if (text !== null) {
    api
      .searchForAdobeStockContents(
        language,
        type,
        encodeURIComponent(text),
        pageIndex,
        'normal'
      )
      .then(res => {
        dispatch(parseAdobeElements(res, theme, text, pageIndex));
      })
      .catch(() => {
        dispatch(setLoadingState(null));
        dispatch(setShowLoading(false));
        const dict = {
          header: '',
          description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
          stringColor: Constants.DEFAULT_STRING_COLOR,
          onclick: null,
          buttonTitles: {
            finish: string.OK_KEY,
            cancel: ''
          }
        };
        dispatch(setMessageDialogParams(dict));
      });
  } else {
    api
      .searchForAdobeStockContents(language, type, null, pageIndex, 'popular')
      .then(res => {
        dispatch(parseAdobeElements(res, theme, text, pageIndex));
        dispatch(setShouldLoadMoreContents(true));
      })
      .catch(() => {
        const dict = {
          header: '',
          description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
          stringColor: Constants.DEFAULT_STRING_COLOR,
          onclick: null,
          buttonTitles: {
            finish: string.OK_KEY,
            cancel: ''
          }
        };
        dispatch(setMessageDialogParams(dict));
      });
  }
};

const parseAdobeElements = (res, theme, text, pageIndex) => (
  dispatch,
  getState
) => {
  dispatch(setLoadingState(null));
  const responseData = res.data.files;

  if (Object.keys(responseData).length === 0) {
    dispatch(setShouldLoadMoreContents(false));
    dispatch(showErrorDialog(Constants.ADOBE_STOCK_IMAGE_SOURCE, pageIndex));
  } else if (getState().sideBar.isMaximumLimit) {
    dispatch(setIsMaximumLimit(false));
  }

  const adobeStockArray = dispatch(
    generateAdobeStockArray(responseData, theme)
  );
  let searchedContentsArray = getState().sideBar.adobeStockData;
  if (searchedContentsArray.length !== 0 && pageIndex !== 1) {
    searchedContentsArray = searchedContentsArray.concat(adobeStockArray);
  } else {
    searchedContentsArray = adobeStockArray;
  }

  if (text !== null) {
    dispatch(setSearchContents(true, searchedContentsArray));
    dispatch(setShouldLoadMoreContents(true));
  } else {
    // text is not null for loadMoreContents flow thereby updating the lists.
    if (theme.elements) {
      dispatch(setSearchContents(true, searchedContentsArray));
    } else {
      theme.elements = adobeStockArray;
    }

    dispatch({
      type: actions.SET_FOLDER_LIST_ELEMENTS,
      payload: { folderListElements: theme }
    });
    dispatch(setShouldLoadMoreContents(false));
  }

  dispatch({
    type: actions.FETCH_ADOBE_STOCK_CONTENTS,
    payload: { adobeStockData: searchedContentsArray }
  });
  dispatch(setShowLoading(false));
};

const generateAdobeStockArray = (inputAdobeStockArray, theme) => (
  dispatch,
  getState
) => {
  const outputAdobeStockArray = createResponseObject(
    inputAdobeStockArray,
    Constants.USER_PHOTO_TYPE,
    Constants.ADOBE_STOCK_IMAGE_SOURCE
  );
  outputAdobeStockArray.forEach(item => {
    item.themeId = theme.id;
    item.themeName = theme.name;
    item.costValue =
      getState().modal.storeData.basePricePerAdobeStockImage +
      getState().modal.storeData.adobeStockSubscriptionPrice;
  });
  dispatch(setContentsUserPhotoType(outputAdobeStockArray));

  return outputAdobeStockArray;
};

export const fetchHPMosaicContents = (theme, pageIndex) => (
  dispatch,
  getState
) => {
  dispatch(setLoadingState(string.LOADING_KEY));

  api
    .searchForHPMosaicContents(pageIndex)
    .then(res => {
      dispatch(setLoadingState(null));
      if (res.status == 200) {
        const hpMosaicDict = res.data.data;
        if (Object.keys(hpMosaicDict).length === 0) {
          dispatch(setShouldLoadMoreContents(false));
          dispatch(
            showErrorDialog(Constants.HP_MOSAIC_IMAGE_SOURCE, pageIndex)
          );
        } else if (getState().sideBar.isMaximumLimit) {
          dispatch(setIsMaximumLimit(false));
        }

        const hpMosaicArray = dispatch(
          generateHPMosaicArray(hpMosaicDict, theme)
        );

        if (pageIndex === 1) {
          dispatch(setHPMosaicData(theme, hpMosaicArray));
        } else {
          let fetchedContentsArray = getState().sideBar.hpMosaicData;
          if (fetchedContentsArray.length !== 0) {
            fetchedContentsArray = fetchedContentsArray.concat(hpMosaicArray);
          } else {
            fetchedContentsArray = hpMosaicArray;
          }
          dispatch(parseHPMosaicData(fetchedContentsArray, theme));
        }
        dispatch(setShowLoading(false));
        dispatch(setShouldLoadMoreContents(false));
      }
    })
    .catch(err => {
      dispatch(setLoadingState(null));
      dispatch(setShowLoading(false));

      if (err) {
        const dict = {
          header: '',
          description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
          stringColor: Constants.DEFAULT_STRING_COLOR,
          onclick: null,
          buttonTitles: {
            finish: string.OK_KEY,
            cancel: ''
          }
        };
        dispatch(setMessageDialogParams(dict));
      }
    });
};

export const randomizeHPMosaicContents = (
  theme,
  pageIndex,
  dispatch,
  getState
) => {
  dispatch(setLoadingState(string.LOADING_KEY));
  api
    .randomizeHPMosaicContents(pageIndex + 1)
    .then(res => {
      dispatch(setLoadingState(null));
      const hpMosaicDict = res.data.data;
      if (Object.keys(hpMosaicDict).length === 0) {
        dispatch(setShouldLoadMoreContents(false));
        dispatch(showErrorDialog(Constants.HP_MOSAIC_IMAGE_SOURCE, pageIndex));
      } else if (getState().sideBar.isMaximumLimit) {
        dispatch(setIsMaximumLimit(false));
      }

      const hpMosaicArray = dispatch(
        generateHPMosaicArray(hpMosaicDict, theme)
      );
      dispatch(parseHPMosaicData(hpMosaicArray, theme));
      dispatch(setShowLoading(false));
      dispatch(setShouldLoadMoreContents(false));
    })
    .catch(() => {
      dispatch(setLoadingState(null));
      dispatch(setShowLoading(false));

      const dict = {
        header: '',
        description: string.ERROR_DIALOG_VIEW_MESSAGE_TEXT,
        stringColor: Constants.DEFAULT_STRING_COLOR,
        onclick: null,
        buttonTitles: {
          finish: string.OK_KEY,
          cancel: ''
        }
      };
      dispatch(setMessageDialogParams(dict));
    });
};

export const setHPMosaicData = (theme, hpMosaicArray) => dispatch => {
  theme.elements = hpMosaicArray;
  dispatch({
    type: actions.SET_FOLDER_LIST_ELEMENTS,
    payload: { folderListElements: theme }
  });
  dispatch({
    type: actions.FETCH_HP_MOSAIC_DATA,
    payload: { hpMosaicData: hpMosaicArray }
  });

  dispatch(setSearchContents(false, null));
};

const parseHPMosaicData = (hpMosaicArray, theme) => dispatch => {
  const searchedContentsArray = hpMosaicArray;
  if (theme.elements) {
    dispatch(setSearchContents(true, searchedContentsArray));
  } else {
    theme.elements = hpMosaicArray;
  }

  dispatch({
    type: actions.SET_FOLDER_LIST_ELEMENTS,
    payload: { folderListElements: theme }
  });
  dispatch({
    type: actions.FETCH_HP_MOSAIC_DATA,
    payload: { hpMosaicData: searchedContentsArray }
  });
};

const generateHPMosaicArray = (inputHPMosaicArray, theme) => (
  dispatch,
  getState
) => {
  const activeTab = getState().sideBar.activeSideBarTab;
  const { partnerStoreType } = getState().modal.storeData;

  const outputHPMosaicArray = createResponseObject(
    inputHPMosaicArray,
    Constants.USER_PHOTO_TYPE,
    Constants.HP_MOSAIC_IMAGE_SOURCE
  );
  outputHPMosaicArray.forEach(item => {
    item.themeId = theme.id;
    item.themeName = theme.name;
    if (
      activeTab == Constants.BACKGROUND_TAB_KEY &&
      partnerStoreType !== Constants.PARTNER_STORE_ARC &&
      getState().modal.envData.category === Constants.GIFTWRAPS_CATEGORY // only for non-arc giftwraps
    ) {
      item.tile = true;
    }
  });
  dispatch(setContentsUserPhotoType(outputHPMosaicArray));
  return outputHPMosaicArray;
};
